module.exports = __webpack_public_path__ + "img/score_item_off.801320a1.svg";